export default {"src":"/_next/static/media/slider_arrow_right_white.76931f2a.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};